import type { RegistryComponentProps } from '@boost-sd/components-registry';
import { registryComponent } from '@boost-sd/components-registry/registry';
import type { ImgHTMLAttributes, MutableRefObject, RefCallback } from 'react';

export type ImageProps = React.DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> &
  RegistryComponentProps<{
    id?: string;
    className?: string;
    src: string;
    alt: string;
    decoding?: ImgHTMLAttributes<HTMLImageElement>['decoding'];
    loading?: ImgHTMLAttributes<HTMLImageElement>['loading'];
    sizes?: string;
    srcSet?: string;
    fetchpriority?: 'high' | 'low' | 'auto';
    innerRef?: MutableRefObject<HTMLImageElement | null> | RefCallback<HTMLImageElement>;
  }>;

const Image = ({
  decoding = 'async',
  loading = 'lazy',
  alt,
  helpersRef,
  innerRef,
  ...imgAttrs
}: ImageProps) => {
  return <img {...imgAttrs} ref={innerRef} decoding={decoding} loading={loading} alt={alt} />;
};

export default registryComponent('Image', Image);
